var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 3.1C20 2.9 19.6 3 19.3 3.3L18.4 4.2C17 5.2 15.1 5.2 13.7 4.2L12.8 3.3C12.4 2.9 11.8 2.9 11.4 3.3L10.5 4.2C9.1 5.2 7.2 5.2 5.8 4.2L4.7 3.3C4.4 3 4 2.9 3.6 3.1C3.2 3.3 3 3.6 3 4V13.2C3 15.9 4.4 18.4 6.7 19.9L11.5 22.9C11.7 23 11.8 23.1 12 23.1C12.2 23.1 12.4 23 12.5 22.9L17.3 19.9C19.6 18.4 21 15.9 21 13.2V4C21 3.6 20.8 3.2 20.4 3.1ZM5 13.2V6.2C6.8 7.3 9.2 7.2 11 6.2V20.2L7.8 18.2C6 17.1 5 15.2 5 13.2ZM19 13.2C19 15.2 18 17.1 16.2 18.2L13 20.2V6.2C14.8 7.2 17.2 7.3 19 6.2V13.2Z",
    fill: "#4D5451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamShield);
export default __webpack_public_path__ + "static/media/team-shield.1fe06b84fd622b84bf313fe5260fc6a3.svg";
export { ForwardRef as ReactComponent };